<script>
  import BaseTable from './table';

  export default {
    components: {
      BaseTable,
    },

    props: {
      url: null,
    },

    data() {
      return {
        items: [],
        isRefreshing: true,
      }
    },

    methods: {
      /**
       * @param {Array} items
       */
      onLoadSuccess({items}) {
        this.items = items;
      },

      /**
       * @param {boolean} value
       */
      onRefresh(value) {
        this.isRefreshing = value;
      },
    }
  }
</script>
